// extracted by mini-css-extract-plugin
module.exports = {"root":"SlickCarousel_root__1lHwa","fadeIn":"SlickCarousel_fadeIn__zK3l7","providerCardSlickCarousel":"SlickCarousel_providerCardSlickCarousel__kKErS"};